<template>
    <v-dialog max-width="700" persistent v-model="dialog">
        <v-card>
            <v-card-title class="headline">{{$parent.selectedApplication.scoringTriggeredByOfficer ? 'Customer Information' : 'Generate Score'}}</v-card-title>
            <v-card-text>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field label="Application Number" readonly
                                              v-model="$parent.selectedApplication.applicationNumber"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field label="Full Name" readonly
                                              v-model="$parent.selectedApplication.fullname"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field label="Identification Number (ID)" readonly
                                              v-model="$parent.selectedApplication.idNumber"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                        :items="dropdown.genders"
                                        item-text="text"
                                        item-value="value"
                                        label="Gender"
                                        readonly
                                        v-model="$parent.selectedApplication.gender"></v-select>

                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field label="Position" readonly
                                            v-model="$parent.selectedApplication.designation"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="8">
                                <v-text-field label="Company Name" readonly
                                              v-model="$parent.selectedApplication.companyName"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Date of Business Commencement" readonly
                                              v-model="$parent.selectedApplication.commencementDate"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                              <v-text-field label="Business Registration Number" readonly
                                            v-model="$parent.selectedApplication.businessRegistrationNumber">
                              </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Branch" readonly
                                              v-model="$parent.selectedApplication.branch"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Product Applied" readonly
                                              v-model="$parent.selectedApplication.productAppliedLabel"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="Business Category" readonly
                                              v-model="$parent.selectedApplication.businessCategoryLabel"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field label="Annual Sales"  prefix="Rp" readonly
                                              v-model="$parent.selectedApplication.annualSales"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Annual Profit" readonly
                                              v-model="$parent.selectedApplication.annualProfit"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Number of full-time employee" readonly
                                              v-model="$parent.selectedApplication.employeesCount"></v-text-field>
                            </v-col>
                        </v-row>
                        <!---->
                        <!---->
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field label="Financing Amount Applied" prefix="Rp" readonly
                                              v-model="$parent.selectedApplication.loanAmount"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Tenure Applied" readonly suffix="Months"
                                              v-model="$parent.selectedApplication.tenureApplied"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field label="Internal Credit Rating" readonly
                                              v-model="$parent.selectedApplication.internalRating"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <div>
                    <div v-show="!$parent.selectedApplication.scoringTriggeredByOfficer" class="mt-2">
                        <p>Are you sure you want to generate GFI scores for this customer?
                            <br/>Please note that you will not be able to change the customer details after scores have been generated.</p>
                    </div>
                    <div v-show="scoreGenerationError">
                        <p class="red--text">We were unable to generate GFI Credit Sore, Please try again later<br/>
                            If the problem persists please contact support</p>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
<!--                <v-skeleton-loader class="mr-3" :loading="loading" transition="scale-transition" type="button">
                    <v-btn @click="dialog=false" color="primary" right>{{$parent.selectedApplication.scoringTriggeredByOfficer ? 'Close' : 'Cancel'}}</v-btn>
                </v-skeleton-loader>
                <v-skeleton-loader v-if="!$parent.selectedApplication.scoringTriggeredByOfficer" :loading="loading" transition="scale-transition" type="button">
                    <v-btn @click="sendGenerateScoreRequest" class="mr-4" color="primary" dark right>Yes</v-btn>
                </v-skeleton-loader>-->
              <v-skeleton-loader class="mr-3" :loading="loading" transition="scale-transition" type="button">
                <v-btn @click="dialog=false" color="primary" right>Close</v-btn>
              </v-skeleton-loader>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {dataServices} from "@/services";

    export default {
        data() {
            return {
                dialog: false,
                dropdown: {},
                scoreGenerationError: false,
                loading: false
            }
        }, methods: {
            init() {
                this.dialog = true
                this.initDropdown()
                this.scoreGenerationError= false
                console.log(this.$parent.selectedApplication)
            },
            sendGenerateScoreRequest() {
                this.scoreGenerationError= false
                this.loading= true
                dataServices.scoreCustomer(this.$parent.selectedApplication).then(() => {
                    this.loading= false
                    this.$parent.renderMessage('GFI Credit Sore for Application Number: '+ this.$parent.selectedApplication.applicationNumber +' was generated successfully')
                    this.dialog = false
                }).catch(error => {
                    this.loading= false
                    this.scoreGenerationError=true
                    console.log('Error' + error)
                })
            },
            initDropdown: function () {
                dataServices.getUserDropDowns(this.$parent.userType.toUpperCase()).then(response => {
                    this.dropdown = response.dataResponse
                    this.loading = false
                })
            }
        }
    }
</script>
